/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=d6ba9410"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d6ba9410&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__